/* @refresh reload */
import { render } from 'solid-js/web';
import App from './App';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root element not found — index.html broken');
}

render(() => <App />, root);
